export function getRawUrl(): string {
  const { host, pathname } = window.location;
  return `${host}${pathname}`;
}

export function redirectEnrollment() {
  const enrollmentsUrl: string = process.env.VUE_APP_ENROLLMENTS_URL ?? '/';
  window.location.replace(enrollmentsUrl);
}
